var React = require('react');

function ArrowLarge (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"10.9595","x2":"26","y2":"10.9595","stroke":"#BDCC2A","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M15.9998 20.8988L25.8491 10.9495L15.9998 1.0001","stroke":"#BDCC2A","strokeWidth":"2","key":1})]);
}

ArrowLarge.defaultProps = {"width":"28","height":"22","viewBox":"0 0 28 22","fill":"none"};

module.exports = ArrowLarge;

ArrowLarge.default = ArrowLarge;
